import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { SelectPortal } from './portal'
import { SelectPositioner, type SelectPositionerProps } from './positioner'
import { SelectPopup } from './popup'
import { SelectScrollUpArrow } from './scroll-up-arrow'
import { SelectScrollDownArrow } from './scroll-down-arrow'

interface SelectContentProps {
  className?: string
  popupClassName?: string
  positionerClassName?: string
  children: ReactNode
  showScrollArrows?: boolean
  positionerProps?: Omit<SelectPositionerProps, 'className' | 'children'>
}

function SelectContent({
  className,
  popupClassName,
  positionerClassName,
  children,
  showScrollArrows = true,
  positionerProps,
}: SelectContentProps) {
  return (
    <SelectPortal>
      <SelectPositioner className={positionerClassName} {...positionerProps}>
        {showScrollArrows && <SelectScrollUpArrow />}
        <SelectPopup className={twMerge(popupClassName, className)}>{children}</SelectPopup>
        {showScrollArrows && <SelectScrollDownArrow />}
      </SelectPositioner>
    </SelectPortal>
  )
}

export { SelectContent }
